import React from 'react';
import { AddIcon } from '@avila-tek/ui/src';
import { PaymentMethod } from '../../../models';
import PaymentDataInput from './PaymentDataInput';

interface PaymentMethodDataProps {
  formState: Partial<PaymentMethod>;
  setFormState: React.Dispatch<React.SetStateAction<Partial<PaymentMethod>>>;
}

function PaymentMethodData({
  formState,
  setFormState,
}: PaymentMethodDataProps) {
  const addPaymentData = () => {
    setFormState({
      ...formState,
      paymentData: [...formState.paymentData, { name: '', value: '' }],
    });
  };
  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex items-center mb-4">
        <h4 className="text-lg font-bold text-purple-300">
          Datos para el pago
        </h4>
        <button
          type="button"
          className="flex ml-auto text-purple-300 font-medium items-center relative z-10"
          onClick={addPaymentData}
        >
          <AddIcon className="w-4 h-4" /> AGREGAR
        </button>
      </div>
      {formState?.paymentData?.length > 0 ? (
        formState?.paymentData?.map((payment, idx) => (
          <PaymentDataInput
            paymentData={payment}
            setFormState={setFormState}
            idx={idx}
          />
        ))
      ) : (
        <div className="w-full text-center">
          <span className="text-neutral-300">
            No tiene datos para el pago aún
          </span>
        </div>
      )}
    </div>
  );
}

export default PaymentMethodData;
